<template>
  <m-contents-wrapper :content-type="contentType" :content-category="contentCategory" @contents="setContents">
    <template slot-scope="{contents}">
      <div class="slider-304">
        <ul class="">
          <li v-for="content in contents" :key="content.id"
              :style="`background-image:url(${content.thumbnail})`">
            <div class="center-y">
              <div class="col-lg-8 mx-auto">
                <h5 class="d-inline-block p-2 rounded-pill">{{ content.title }}</h5>
              </div>
              <m-a class="" :href="{name:'SinglePage',params:{slug:content.slug}}">
                <m-bt503 class="rounded-pill mt-3">
                  <template #p-2>مشاهده</template>
                </m-bt503>
              </m-a>
            </div>
          </li>
        </ul>

        <ul>
          <nav>
            <a class="mx-2" v-for="content in contents" :key="content.id" href="#"></a>
          </nav>
        </ul>
      </div>
    </template>
  </m-contents-wrapper>
</template>

<script>
// slider source: https://codepen.io/aspeddro/pen/KzGEQL
export default {
  name: "Slider304",
  props: {
    contentCategory: {
      default: () => {
        return ['header-slider']
      }
    },
    contentType: {
      default: 'page'
    }
  },
  data() {
    return {
      el: '',
      Slides: '',
      Nav: '',
      totalSlides: '',
      current: '',
      autoPlay: '',
      timeTrans: '',
      IndexElements: '',
      contentsLength: 0,
    }
  },
  methods: {
    constructor() {
      this.el = document.querySelector('.slider-304');
      this.Slides = Array.from(this.el.querySelectorAll('li'));
      this.Nav = Array.from(this.el.querySelectorAll('nav a'));
      this.totalSlides = this.contentsLength
      this.current = 0;
      this.autoPlay = true; //true or false
      this.timeTrans = 7000; //transition time in milliseconds
      this.IndexElements = [];

      for (let i = 0; i < this.totalSlides; i++) {
        this.IndexElements.push(i);
      }

      this.setCurrent();
      this.initEvents();
    },
    setCurrent() {
      this.Slides[this.current].classList.add('current');
      this.Nav[this.current].classList.add('current_dot');
    },
    initEvents() {
      const self = this;

      this.Nav.forEach((dot) => {
        dot.addEventListener('click', (ele) => {
          ele.preventDefault();
          this.changeSlide(this.Nav.indexOf(dot));
        })
      })

      this.el.addEventListener('mouseenter', () => self.autoPlay = false);
      this.el.addEventListener('mouseleave', () => self.autoPlay = true);

      setInterval(function () {
        if (self.autoPlay) {
          self.current = self.current < self.Slides.length - 1 ? self.current + 1 : 0;
          self.changeSlide(self.current);
        }
      }, this.timeTrans);

    },
    changeSlide(index) {
      this.Nav.forEach((allDot) => allDot.classList.remove('current_dot'));

      this.Slides.forEach((allSlides) => allSlides.classList.remove('prev', 'current'));

      const getAllPrev = value => value < index;

      const prevElements = this.IndexElements.filter(getAllPrev);

      prevElements.forEach((indexPrevEle) => this.Slides[indexPrevEle].classList.add('prev'));

      this.Slides[index].classList.add('current');
      this.Nav[index].classList.add('current_dot');
    },
    setContents(contents) {
      this.contentsLength = contents.length
      setTimeout(() => {
        this.constructor()
      }, 500)
    }
  },
}
</script>

<style scoped>
.slider-304 {
  position: relative;
  width: 100%;
  min-height: 550px;
}

.slider-304 nav a {
  background: var(--secondary) !important;
}

.slider-304 h5 {
  background: var(--primary);
}

.slider-304 li {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  transition: clip 0.7s ease-in-out, z-index 0s 0.7s;
  clip: rect(0, 100vw, 100vh, 100vw);
  display: table;
}

.center-y {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: #fff;
}

ul {
  margin: 0 !important;
}

li.current h3,
li.current h3 + a {
  opacity: 1;
  transition-delay: 1s;
  transform: translate3d(0, 0, 0);
}

li.current {
  z-index: 1;
  clip: rect(0, 100vw, 100vh, 0);
}

li.prev {
  clip: rect(0, 0, 100vh, 0);
}

.slider-304 nav {
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}

nav a {
  display: inline-block;
  border-radius: 50%;
  width: 1.2rem;
  height: 1.2rem;
  min-width: 12px;
  min-height: 12px;
  background: #fff;
  transition: transform 0.3s;
}

a.current_dot {
  transform: scale(1.4);
}
</style>